import { defineMessages } from 'react-intl';

export default defineMessages({
  tooltipMessage: {
    id: 'accountSignin.forgotUsernameLink.tooltipMessage',
    defaultMessage: 'You can now use your email instead of a username.',
    description:
      'Tooltip message telling user to use email instead of username',
  },
  forgotUsernameLink: {
    id: 'accountSignin.forgotUsernameLink.linkText',
    defaultMessage: 'Forgot your username?',
    description: 'Link for users who forgot their username',
  },
});
